import axios from 'axios';
import CookieService from '../services/CookieService'; // Import CookieService
import { redirectToCustomerPortal } from './portalUrl';

// Create axios instance
const axiosInstance = axios.create({
    baseURL: '/api',
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor to set Authorization header
axiosInstance.interceptors.request.use(
    (config) => {
        const token = CookieService.getToken(); // Use CookieService instead of localStorage
        console.log('Token from CookieService:', token); // Updated debug log
        if (token) {
            config.headers = {
                ...config.headers,
                'Authorization': `Bearer ${token}`
            };
            console.log('Request headers:', config.headers); // Debug log
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            CookieService.logout(); // Use CookieService to clear auth cookies
            redirectToCustomerPortal({ returnUrl: window.location.href });
        } else if (error.response && error.response.status === 403) {
            redirectToCustomerPortal({ path: '/marketplace' });
        }
        return Promise.reject(error);
    }
);

export default axiosInstance; 